module.exports = __webpack_public_path__ + "img/share-white.2e8140db.svg";